import enTranslations from "@shopify/polaris/locales/en.json";
import { AppProvider } from "@shopify/polaris";
import { Provider } from "react-redux";
import { store } from "../store/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import React, { createContext, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";


import MainLayout from "../components/layouts/MainLayout";

import StartDesigning from "../pages/StartDesigning/StartDesigning";

export const DASHBOARD_PATH = "/";

export const AppContext = createContext<any>(null);
export const ConfigContext = createContext<any>(null);

export const AppRouter: React.FC = () => {
  const [ruleConfig, setRuleConfig] = useState({
    headingText: "",
    addDescription: "",
    title: "",
    active: false,
    combination: ["product", "shipping", "order"],
    tiersType: "percentage",
    tiers: [
      { id: 1, min: 6, discount: 10 },
      { id: 2, min: 12, discount: 15 },
      { id: 3, min: 24, discount: 20 },
      { id: 4, min: 48, discount: 25 },
      { id: 5, min: 96, discount: 30 },
      { id: 6, min: 144, discount: 35 },
      { id: 7, min: 288, discount: 40 },
      { id: 8, min: 576, discount: 45 },
    ],
  });

  const [config, setConfig] = useState({
    showSidebar: true,
  });

  const protectedLayout = <MainLayout />;

  const homepage = <StartDesigning />;

  return (
    <AppProvider i18n={enTranslations}>
      <Provider store={store}>
        <div className="font-sans">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <AppContext.Provider value={{ config, setConfig }}>
            <ConfigContext.Provider value={{ ruleConfig, setRuleConfig }}>
              <BrowserRouter>
                <Routes>
                  <Route path={DASHBOARD_PATH} element={protectedLayout}>
                    <Route path="/" element={homepage} />
                    <Route
                      path="/product-catalog/:productId/start-designing"
                      element={<StartDesigning />}
                    ></Route>
                    <Route
                      path="/product-catalog/:productId/edit-designing/:designId"
                      element={<StartDesigning />}
                    ></Route>
                  </Route>
                </Routes>
              </BrowserRouter>
            </ConfigContext.Provider>
          </AppContext.Provider>
        </div>
      </Provider>
    </AppProvider>
  );
};
